import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { leadGeneration, notify, OtpVerify, verifyUser } from "../../API/API";
import { showToast } from "../../components/common/Util/Util";

const TalkToAdviser = ({
  showTalkToAdviser,
  setShowTalkToAdviser,
  setShowThankYouPopUp,
}) => {
  const ip = useSelector((state) => state.user.ip);
  const cordinates = useSelector((state) => state.user.cordinates);
  const userData = useSelector((state) => state.user.user);
  const [customerNum, setCustomerNum] = useState(
    userData?.MobileNumber ? userData?.MobileNumber : ""
  );
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState("");
  const isLoggedIn = !!userData?.ID || !!userData?.id;

  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();
  useEffect(() => {
    setCustomerNum(userData?.MobileNumber);
    setValue("mobileNumber", userData?.MobileNumber);
  }, [userData]);
  const handleClose = () => {
    setOtpSent(false);
    setOtp("");
    setCustomerNum("");
    setShowTalkToAdviser(false);
  };
  const notificationRequest = {
    userId: null,
    title: "New Lead Generated",
    content: `A new advisor lead has been generated by ${
      userData.Name || userData.name
    }.`,
    createdByRole: "USER",
    type: "leadGeneration",
    action: "View Lead",
    actionUrl: "/leads",
    unread: true,
  };
  const handleLeadGenration = () => {
    const verifyOtpRequest = {
      mobileNumber: customerNum?.replace(/-/g, ""),
      mobileOtp: otp,
    };
    if (otp === "") {
      showToast("Please enter the OTP", "error");
      return;
    } else if (otp?.length !== 4) {
      showToast("Please enter the complete OTP", "error");
      return;
    }
    setLoading(true);
    OtpVerify(verifyOtpRequest)
      .then((res) => {
        if (res?.statusCode === 200 && res?.message === "OTP Verified") {
          const leadRequest = {
            mobileNumber: customerNum?.replace(/-/g, ""),
            leadType: "advisor",
            ip: ip,
            longitude: String(cordinates?.lng ? cordinates?.lng : ""),
            latitude: String(cordinates?.lat ? cordinates?.lat : ""),
          };
          leadGeneration(leadRequest)
            .then((res) => {
              if (res.statusCode === 200) {
                notify(notificationRequest);
                setOtpSent(false);
                setOtp(false);
                setLoading(false);
                setShowThankYouPopUp(true);
                handleClose();
              } else {
                setLoading(false);
                showToast("Oops! Something went wrong.", "error");
              }
            })
            .catch((err) => {
              console.error("error", err);
              showToast("Oops! Something went wrong.", "error");
              setLoading(false);
            });
        } else {
          setLoading(false);
          showToast(res.message || "Oops! Something went wrong.", "error");
        }
      })
      .catch((err) => {
        console.error(err);
        showToast("Oops! Something went wrong.", "error");
        setLoading(false);
      });
  };
  const onSubmit = (data) => {
    let leadRequest = {
      mobileNumber: customerNum?.replace(/-/g, ""),
      ip: ip,
      longitude: String(cordinates?.lng ? cordinates?.lng : ""),
      latitude: String(cordinates?.lat ? cordinates?.lat : ""),
      screen: "advisor",
      ...(!isLoggedIn && data.name && { entityName: data.name }),
    };
    if (userData?.MobileNumber !== customerNum?.replace(/-/g, "")) {
      setLoading(true);
      verifyUser(leadRequest)
        .then((res) => {
          if (res?.statusCode === 200) {
            setLoading(false);
            showToast(res.message, "success");
            setOtpSent(true);
          } else if (res?.statusCode === 208) {
            leadGeneration({
              ...leadRequest,
              leadType: "advisor",
            })
              .then((res) => {
                if (res.statusCode === 200) {
                  notify(notificationRequest);
                  setLoading(false);
                  setShowThankYouPopUp(true);
                  setShowTalkToAdviser(false);
                } else {
                  setLoading(false);
                  showToast("Oops! Something went wrong.", "error");
                }
              })
              .catch((err) => {
                setLoading(false);
                showToast("Oops! Something went wrong.", "error");
                console.error(err);
              });
          }
        })
        .catch((error) => {
          setLoading(false);
          showToast("Oops! Something went wrong.", "error");
          console.error(error);
        });
    } else {
      setLoading(true);
      leadGeneration({
        ...leadRequest,
        leadType: "advisor",
      })
        .then((res) => {
          if (res?.statusCode === 200) {
            setLoading(false);
            notify(notificationRequest);
            setShowThankYouPopUp(true);
            setShowTalkToAdviser(false);
          } else {
            setLoading(false);
            showToast("Oops! Something went wrong.", "error");
          }
        })
        .catch((err) => {
          setLoading(false);
          showToast("Oops! Something went wrong.", "error");
          console.error(err);
        });
    }
  };

  return (
    <Dialog
      open={showTalkToAdviser}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "20px",
          padding: "20px",
        },
      }}
    >
      <Backdrop sx={{ color: "#fff", zIndex: 1000 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <DialogContent>
        {/* Flexbox Section */}
        <Box display="flex" alignItems="center" justifyContent="space-evenly">
          <Box flex={1}>
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{ color: "#004AAD" }}
            >
              Free Consultation
            </Typography>
            <Typography
              variant="body1"
              mt={1}
              sx={{ fontStyle: "italic", fontSize: "0.8rem", width: "250px" }}
            >
              Get expert assistance for your loan application. Share your
              details, and our advisor will reach out to you within 30 minutes
              during business hours.
            </Typography>
          </Box>
          <Box display="flex" justifyContent="center">
            <img
              src="/TalkToAdviserImg.png"
              alt="Popup Img"
              style={{ maxWidth: "100px" }}
            />
          </Box>
        </Box>

        {!isLoggedIn && !otpSent && (
          <Box mt={3} display="flex" justifyContent="center">
            <Controller
              name="name"
              control={control}
              rules={{
                required: "Name is required",
                minLength: {
                  value: 2,
                  message: "Name must be at least 2 characters",
                },
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  variant="outlined"
                  fullWidth
                  label={
                    <>
                      Name
                      <span style={{ color: "red" }}>*</span>
                    </>
                  }
                  autoFocus
                  sx={{
                    marginBottom: "1rem",
                    "& input::placeholder": {
                      color: "#A8A8A8",
                    },
                  }}
                  error={!!errors.name}
                  placeholder="Enter your name"
                  helperText={errors.name?.message}
                />
              )}
            />
          </Box>
        )}

        {/* Phone Number Input */}
        {!otpSent ? (
          <Box mt={3} display="flex" justifyContent="center">
            <Controller
              name="mobileNumber"
              control={control}
              rules={{
                required: "Mobile number is required",
                validate: (value) => {
                  const digitsOnly = value.replace(/\D/g, "");
                  return (
                    digitsOnly.length === 10 ||
                    "Mobile number must be 10 digits"
                  );
                },
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  variant="outlined"
                  fullWidth
                  label={
                    <>
                      Mobile Number
                      <span style={{ color: "red" }}>*</span>
                    </>
                  }
                  type="tel"
                  autoFocus={isLoggedIn}
                  slotProps={{
                    htmlInput: {
                      maxLength: 10,
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                    },
                    inputLabel: { shrink: true },
                  }}
                  onInput={(e) => {
                    e.target.value.replace(/^\s+/, "");
                    e.target.value = e.target.value.replace(/[^0-9]/g, "");
                    e.target.value = e.target.value.replace(
                      /(\d{3})(\d{3})(\d{4})/,
                      "$1-$2-$3"
                    );
                    field.onChange(e);
                    setCustomerNum(e.target.value);
                  }}
                  sx={{
                    marginBottom: "1rem",
                    "& input::placeholder": {
                      color: "#A8A8A8",
                    },
                  }}
                  error={!!errors.mobileNumber}
                  placeholder="XXX-XXX-XXXX"
                  helperText={errors.mobileNumber?.message}
                />
              )}
            />
          </Box>
        ) : (
          <Box mt={3} display="flex" justifyContent="center">
            <Controller
              name="otp"
              control={control}
              rules={{
                required: "OTP is required",
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  variant="outlined"
                  required
                  fullWidth
                  value={otp}
                  label="OTP"
                  type="tel"
                  autoFocus
                  onChange={(e) => {
                    setOtp(e.target.value);
                  }}
                  inputProps={{ maxLength: 4 }}
                  sx={{
                    marginBottom: "1rem",
                    "& input::placeholder": {
                      color: "#A8A8A8", // Placeholder color
                    },
                  }}
                  error={!!errors.mobileNumber}
                  placeholder="Enter OTP" // Placeholder format
                  helperText={errors.mobileNumber?.message}
                />
              )}
            />
          </Box>
        )}

        {/* Submit Button */}
        {!otpSent ? (
          <Box mt={2} display="flex" justifyContent="center">
            <Button
              variant="contained"
              fullWidth
              sx={{
                maxWidth: "350px",
                backgroundColor: "#004AAD",
                textTransform: "none",
                padding: 1.5,
              }}
              onClick={handleSubmit(onSubmit)}
            >
              Proceed
            </Button>
          </Box>
        ) : (
          <Box mt={2} display="flex" justifyContent="center">
            <Button
              variant="contained"
              fullWidth
              sx={{
                maxWidth: "350px",
                backgroundColor: "#004AAD",
                textTransform: "none",
                padding: 1.5,
              }}
              onClick={() => handleLeadGenration()}
            >
              verify
            </Button>
          </Box>
        )}

        {/* Text Button */}
        <Box mt={1} display="flex" justifyContent="center">
          <Button
            variant="text"
            sx={{ maxWidth: "350px", color: "#004AAD", textTransform: "none" }}
            onClick={() => {
              handleClose();
            }}
          >
            Cancel
          </Button>
        </Box>

        {/* Additional Text */}
        <Box mt={2} display="flex" justifyContent="center">
          <Typography sx={{ fontStyle: "italic", fontSize: "0.8rem" }}>
            You will receive a call from Dequitec within 30 minutes during
            business hours..*
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default TalkToAdviser;
